import { render, staticRenderFns } from "./ExclusiveBlock.vue?vue&type=template&id=313481dd&scoped=true"
import script from "./ExclusiveBlock.vue?vue&type=script&lang=ts"
export * from "./ExclusiveBlock.vue?vue&type=script&lang=ts"
import style0 from "./ExclusiveBlock.vue?vue&type=style&index=0&id=313481dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313481dd",
  null
  
)

export default component.exports